export class ApiError extends Error {
    code;
    status;
    details;
    codeIsSynthesized;
    constructor(code, message, status, details, 
    /**
     * True when `code` was derived from the HTTP status because the response
     * body carried none (see `mapStatusToCode`). Such a code is a guess — e.g.
     * `invalid_credentials` for ANY code-less 401 — so translators prefer the
     * status over it. Defaults to false: every server-sent code is authoritative.
     */
    codeIsSynthesized = false) {
        super(message);
        this.code = code;
        this.status = status;
        this.details = details;
        this.codeIsSynthesized = codeIsSynthesized;
        this.name = 'ApiError';
    }
}
/** Thrown by createTicket when the API returns 409 duplicate_active_ticket. */
export class DuplicateTicketApiError extends ApiError {
    existingTicketNumber;
    constructor(existingTicketNumber, message = 'An active ticket for this plate already exists') {
        super('duplicate_active_ticket', message, 409);
        this.existingTicketNumber = existingTicketNumber;
        this.name = 'DuplicateTicketApiError';
    }
}
//# sourceMappingURL=errors.js.map